<template>
  <v-footer dark padless>
    <v-card class="flex" flat tile>
      <v-card-title class="error">
        <span
          class="col-12 col-md-6 text-center text-md-left subtitle-1 pa-0 font-weight-bold"
        >Get connected with me on social networks!</span>
        <v-spacer></v-spacer>
        <div class="text-center col-12 col-md-6 pa-0 text-md-right">
          <v-btn
            icon
            href="https://www.npmjs.com/package/vue-circle-control-slider"
            target="_blank"
          >
            <v-icon size="46px">mdi-npm</v-icon>
          </v-btn>
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon medium>mdi-skype</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>tvcoproration</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon medium>mdi-gmail</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>mr.1bilous@gmail.com</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn icon href="https://www.facebook.com/profile.php?id=100010936621691">
            <v-icon medium>mdi-facebook</v-icon>
          </v-btn>
          <v-btn icon href="https://www.linkedin.com/in/vasyl-bilous-b980b217b">
            <v-icon medium>mdi-linkedin</v-icon>
          </v-btn>
          <v-btn icon href="https://github.com/00King00/VueCircleControlSlider">
            <v-icon medium>mdi-github-circle</v-icon>
          </v-btn>
          <v-btn icon href="https://mr-bilous.firebaseapp.com" target="_blank">
            <v-icon>mdi-newspaper</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <v-card-text class="py-2 white--text text-center black">
        {{ new Date().getFullYear() }} — vue-circle-control-slider created by
        <strong>Vasyl Bilous</strong> - gitHub 00King00
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
export default {
    name: 'footer',
}
</script>
<style scoped>
.v-icon:hover{
  font-size: 60px !important;
}
</style>